/**
 * Разделы панели.
 *
 * Меню зависит от выбранного раздела: «Зарядные станции» и «Прокат» —
 * это два независимых набора пунктов, а не один общий список.
 */

export const CHARGING = 'charging';
export const RENTAL = 'rental';

const RENTAL_PATHS = ['rental'];

/**
 * Определяет раздел по текущему пути. Настройки профиля общие для обоих
 * разделов, поэтому раздел для них берётся из последнего выбранного.
 */
export function sectionByPath(pathName) {
  return RENTAL_PATHS.includes(pathName) ? RENTAL : CHARGING;
}

export function isRentalOnlyRole(role) {
  return role === 'rental-manager';
}

export function canUseRental(role) {
  return role === 'administrator' || role === 'rental-manager';
}

export function canUseCharging(role) {
  return role !== 'rental-manager';
}
